import { Edit } from "@mui/icons-material";
import { FormControl, FormHelperText, Tooltip, Button, Typography } from "@mui/material";
import { useState } from "react";

import SmartyAutoComplete from "../../../../global/SmartyAutoComplete";
import HNSColors from "../../../../ui library/HNSColors";
import SaveButton from "../Buttons/SaveButton";

export default function AddressField({ value, onChange }) {
  const [isEditing, setIsEditing] = useState(false);
  const [hovered, setHovered] = useState(false);

  return (
    <FormControl variant="outlined" className="w-full">
      <FormHelperText className="m-0 pb-2 text-base font-semibold">Address:</FormHelperText>

      {isEditing ? (
        <div>
          <SmartyAutoComplete
            address={value}
            setAddress={onChange}
            hideLabel={true}
            inputSx={{
              "& .MuiOutlinedInput-root:hover fieldset": {
                borderColor: HNSColors.neutrals[400],
              },
              "& .MuiOutlinedInput-root fieldset": {
                borderColor: HNSColors.neutrals[500],
              },
              "& .MuiOutlinedInput-root:hover:not(.Mui-focused) fieldset": {
                borderColor: HNSColors.neutrals[500],
              },
            }}
          />
          {
            <SaveButton
              disabled={false}
              onClick={() => setIsEditing(false)}
              label={"Done"}
              color={HNSColors.tertiary[600]}
              hoverColor={HNSColors.tertiary[700]}
            />
          }
        </div>
      ) : (
        <Tooltip title="Click to edit">
          <span>
            <Button
              className="h-min-[48px] flex w-full flex-row justify-between break-all rounded bg-white px-3 py-4 text-left normal-case text-black hover:bg-gray-200"
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              onClick={() => setIsEditing(true)}
              sx={{
                border: `1px solid ${hovered ? HNSColors.neutrals[400] : HNSColors.neutrals[500]}`,
              }}
            >
              <Typography className="align-left">
                {value?.raw && value.raw.trim() !== "" ? (
                  value.raw
                ) : (
                  <span className="text-gray-400">Add Address</span>
                )}
              </Typography>
              {hovered && (
                <span>
                  <Edit className="text-gray-400" />
                </span>
              )}
            </Button>
          </span>
        </Tooltip>
      )}
    </FormControl>
  );
}
